<template>
    <section class="invoice_container">
        <h2>发票管理</h2>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">开发票</el-menu-item>
            <el-menu-item index="2">发票记录</el-menu-item>
        </el-menu>
        <router-view/>
    </section>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: '1'
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      if (key === '1') {
        this.$router.push({
          path: '/invoice/apply'
        }).catch(err => {})
      } else if (key === '2') {
        this.$router.push({
          path: '/invoice/history'
        }).catch(err => {})
      }
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'applyInvoice' || to.name === 'invoice') {
        this.activeIndex = '1'
      } else if (to.name === 'invoiceHistory') {
        this.activeIndex = '2'
      }
    }
  },
  created () {
    let componentName = this.$route.name
    console.log('componentName', componentName)
    if (componentName === 'invoice') {
      this.$router.push({
        path: '/invoice/apply'
      }).catch(err => {})
      this.activeIndex = '1'
    } else if (componentName === 'applyInvoice') {
      this.activeIndex = '1'
    } else if (componentName === 'invoiceHistory') {
      this.activeIndex = '2'
    }
  }
}
</script>

<style lang="stylus">
    @import "../../styles/nav_horizontal.styl"
    .invoice_container
      background-color: #fff
    .el-menu-demo
      padding-left: 20px
</style>
